import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'

import { buildTranslate } from 'locales'

import NoMatchBadge from './NoMatchBadge'

const t = buildTranslate('components.ai.picker.canonical.paste')

export interface NotFoundUid {
  uid: string
  isAdded: boolean
}

type Props = {
  uids: NotFoundUid[]
  onAdd: (uid: string) => void
  onAddAll: () => void
}

/**
 * The searched uids nothing in the catalog holds, each with a way to add it
 * anyway as a pick that matches nothing, and one way to add them all.
 */
const NotFoundUids = ({ uids, onAdd, onAddAll }: Props) => {
  const notAddedCount = uids.filter(({ isAdded }) => !isAdded).length

  return (
    <div className="px-m py-s border-top">
      {notAddedCount > 1 && (
        <div className="d-flex justify-content-end">
          <Button
            kind="minimal"
            size="small"
            className="p-0"
            onClick={onAddAll}
          >
            {t('add_all')}
          </Button>
        </div>
      )}
      <ul className="list-unstyled m-0">
        {uids.map(({ uid, isAdded }) => (
          <li key={uid} className="d-flex align-items-center py-xxs">
            <Text.BodyText4 color="grey90" className="mr-xs">
              {t('not_found', { uid })}
            </Text.BodyText4>
            {isAdded ? (
              <span className="ml-auto d-inline-flex align-items-center">
                <NoMatchBadge />
                <Text.BodyText5 color="grey70" className="ml-xs">
                  {t('added')}
                </Text.BodyText5>
              </span>
            ) : (
              <Button
                kind="minimal"
                size="small"
                className="ml-auto p-0"
                aria-label={t('add_label', { uid })}
                onClick={() => onAdd(uid)}
              >
                {t('add')}
              </Button>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default NotFoundUids
